import React from 'react'
import { connect } from 'react-redux'
import { Outlet } from 'react-router-dom'
import { appSearch, appStatus } from '../../redux/selectors'
import {fetchMenu} from '../../redux/reducers'
import Search from '../search/search'
import Header from '../header/header'
import Footer from '../footer/footer'
import Error from '../error/error'

class Layout extends React.Component {
   state = { hasError: false }
   static getDerivedStateFromError() {
      return { hasError: true }
   }

   componentDidMount() {
      this.props.fetchMenu()
   }

   render() {
      const { search, status } = this.props

      const clearLayoutError = () => {
         this.setState({ hasError: false })
      }

      if (status !== 'ok' || this.state.hasError) return <Error clearLayoutError={clearLayoutError} />

      return (
         <>
            <Header />
            {search && <Search />}
            <Outlet />
            <Footer />
         </>
      )
   }
}

const mapStateToProps = (state) => ({
   search: appSearch(state),
   status: appStatus(state)
})

export default connect(mapStateToProps, {fetchMenu})(Layout)
